import { render } from "./WCToastRootModern.vue?vue&type=template&id=717906ad&scoped=true"
import script from "./WCToastRootModern.vue?vue&type=script&lang=js"
export * from "./WCToastRootModern.vue?vue&type=script&lang=js"

import "./WCToastRootModern.vue?vue&type=style&index=0&id=717906ad&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717906ad"]])

export default __exports__